import React, { useRef, useEffect,useState} from 'react';
import Hls from 'hls.js';
import VideoPlayer from 'react-video-js-player';

const HLSPlayer = ({ url,id }) => {
  const videoRef = useRef();
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    let hls;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(videoRef.current);
    } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      // This will work in Safari
      videoRef.current.src = url;
    } else {
      console.error('HLS is not supported in this browser');
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [url]);

  //return <video ref={videoRef} controls style={{ width: '100%' }} />;
  return(

    <>
      <p align="center">
       <VideoPlayer
            ref={videoRef} 
            id={id}
            src={url}
            poster={process.env.REACT_APP_VIDEOSERVER_API+id+'.jpg'}
            width="640"
            height="400"
        /> 
        </p>
      {/* <video ref={videoRef} controls style={{ width: '100%' }} poster={process.env.REACT_APP_VIDEOSERVER_API+id+'.jpg'}/> */}
    </>

  )
};

export default HLSPlayer;